import $ from 'jquery'
import type { JQuery } from 'jquery'
import type { Moment } from 'moment'

// -----------------------------------------------------------------------------
// GLOBAL LIBRARY FIX
// -----------------------------------------------------------------------------
// We wrap this in a block to ensure we don't pollute the variable namespace
(() => {
  const DP = $.fn.datetimepicker as any
  if (!DP || !DP.Constructor) return

  const proto = DP.Constructor.prototype
  if (!proto._origSetValue) {
    proto._origSetValue = proto._setValue
    proto._setValue = function _setValue (targetMoment: any, index: any) {
      if (
        !targetMoment &&
        (!this._options.allowMultidate || this._dates.length === 1)
      ) {
        const oldDate = this.unset ? null : this._dates[index]

        this.unset = true

        this._dates = [this.getMoment()]
        this._datesFormatted = []

        this._viewDate = this.getMoment().locale(this._options.locale).clone()

        if (this.input !== undefined) {
          this.input.val('')
          this.input.trigger('input')
        }

        this._element.data('date', '')

        this._notifyEvent({
          type: DP.Constructor.Event.CHANGE,
          date: false,
          oldDate: oldDate
        })

        this._update()
      } else {
        this._origSetValue(targetMoment, index)
      }
    }
  }
})()
// -----------------------------------------------------------------------------

function configureCancellableDateTimePicker (
  pickerElement: JQuery<HTMLElement>,
  id: string,
  onSave?: (date: Moment | null) => void): void {
  let shouldSave = false
  let changedDateTime: Moment | null = null
  let originalDateTime: Moment | null = pickerElement.datetimepicker('date')

  $(document)
    .off(`mousedown.dateTimePicker.${id}`)
    .on(`mousedown.dateTimePicker.${id}`, (event) => {
      const target = $(event.target)
      if (target.closest('.bootstrap-datetimepicker-widget').length > 0) {
        return
      }
      if (target.closest(pickerElement).length > 0) {
        return
      }
      shouldSave = false
      changedDateTime = null
      pickerElement.datetimepicker('hide')
    })

  pickerElement.on('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      pickerElement.datetimepicker('hide')
    }
  })

  pickerElement.on('cancellableDateTimePicker:sync', (_event, syncedDate) => {
    if (syncedDate) {
      originalDateTime = syncedDate
      pickerElement.datetimepicker('date', syncedDate)
    } else {
      originalDateTime = pickerElement.datetimepicker('date')
    }
    shouldSave = false
    changedDateTime = null
  })

  pickerElement.on('show.datetimepicker', () => {
    shouldSave = true
  })

  pickerElement.on('change.datetimepicker', ({ date }) => {
    shouldSave = true
    changedDateTime = date
  })

  pickerElement.on('hide.datetimepicker', ({ date }) => {
    if (!shouldSave) {
      shouldSave = false
      changedDateTime = null
      pickerElement.datetimepicker('date', originalDateTime)
      return
    }
    if (!changedDateTime) {
      changedDateTime = date
    }
    originalDateTime = changedDateTime
    onSave?.(changedDateTime)
    shouldSave = false
    changedDateTime = null
  })
}

export { configureCancellableDateTimePicker }
